import React, { useEffect } from "react";
import { ISearchContext, useSearch } from "./SearchContext";

export interface ISortProps {
  label?: string;
  param?: string;
  className?: string;
  sorts: {
    key: string;
    label: string;
    cb: (arg0: any, arg1: any) => number;
  }[];
  context: ISearchContext;
}

export const Sort: React.FC<ISortProps> = ({
  className,
  param,
  sorts,
  label,
  context,
}) => {
  useEffect(() => {
    // Register sorts.

    if (context.currentSort && !context.currentSort.size) {
      sorts.map((sort) => context.currentSort?.set(sort.key, sort.cb));
    }

  }, []);


  return (
    <div className={className}>
      {label}
      <select
        name={param}
        onChange={(event) => {
          context.setSortValue && context.setSortValue(event.target.value);
        }}
        value={context.sortValue || ""}
      >
        <option>- default -</option>
        {sorts.map((sort, index) => (
          <option key={sort.key} value={sort.key}>
            {sort.label}
          </option>
        ))}
      </select>
    </div>
  );
};
